import { Cookies } from 'react-cookie';

import { LocationsOnMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const putLocationOnMap = async (slug: string, locationId: number, updatedLocationData: any) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(`v1/floor-plans/${slug}/locations/${locationId}/`, updatedLocationData, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as LocationsOnMapResponse;
};
